import { useEffect, useState } from 'react';

const TERM = [
  { type: 'cmd', text: 'python train_model.py --data sensors.csv' },
  { type: 'out', text: 'Loading dataset... 14,200 samples' },
  { type: 'out', text: 'Preprocessing pipeline OK' },
  { type: 'hi',  text: '▸ Training Isolation Forest + LSTM...' },
  { type: 'out', text: 'Epoch 12/12 — loss: 0.0042' },
  { type: 'hi',  text: '✓ Anomaly threshold: 0.87' },
  { type: 'out', text: 'Real-time alert system: ACTIVE' },
  { type: 'cmd', text: 'monitor --live' },
  { type: 'hi',  text: '▸ Anomaly detected! [Sensor T-04]' },
  { type: 'out', text: 'Alert sent → dashboard & email' },
];

function Terminal() {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (n >= TERM.length) return;
    const t = setTimeout(() => setN(v => v + 1), 300);
    return () => clearTimeout(t);
  }, [n]);

  return (
    <div style={{
      position: 'absolute', right: '3rem', top: '50%', transform: 'translateY(-50%)',
      width: 385, background: '#0f1c24', border: '1px solid #1a3040',
      fontFamily: "'Space Mono', monospace", fontSize: '0.72rem',
      animation: 'fadeUp 0.6s 0.5s ease both',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '0.6rem 1rem', background: '#0b1318', borderBottom: '1px solid #1a3040' }}>
        {['#ff5f56','#ffbd2e','#27c93f'].map((c,i) => <span key={i} style={{ width:10, height:10, borderRadius:'50%', background:c, display:'block' }} />)}
        <span style={{ color: '#5a8a9f', fontSize: '0.62rem', marginLeft: 'auto' }}>anomaly_monitor.py</span>
      </div>
      <div style={{ padding: '1.2rem', lineHeight: 2.1 }}>
        {TERM.slice(0, n).map((line, i) => (
          <div key={i} style={{ display: 'flex', gap: 8 }}>
            {line.type === 'cmd' && <span style={{ color: '#a8ff3e' }}>$</span>}
            <span style={{
              color: line.type === 'hi' ? '#00e5ff' : line.type === 'cmd' ? '#e2f0f5' : '#5a8a9f',
              paddingLeft: line.type !== 'cmd' ? '1.4rem' : 0,
            }}>{line.text}</span>
          </div>
        ))}
        {n >= TERM.length && (
          <div style={{ display: 'flex', gap: 8 }}>
            <span style={{ color: '#a8ff3e' }}>$</span>
            <span style={{ display:'inline-block', width:7, height:'1em', background:'#00e5ff', animation:'blink 1s step-end infinite', verticalAlign:'text-bottom' }} />
          </div>
        )}
      </div>
    </div>
  );
}

export default function Hero() {
  const [wide, setWide] = useState(window.innerWidth >= 1100);
  useEffect(() => {
    const fn = () => setWide(window.innerWidth >= 1100);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  return (
    <section style={{ position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', padding: '0 3rem', overflow: 'hidden' }}>
      {/* Glows */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(ellipse 60% 50% at 70% 50%, rgba(0,229,255,0.07) 0%, transparent 70%), radial-gradient(ellipse 40% 40% at 20% 80%, rgba(255,77,109,0.05) 0%, transparent 60%)',
      }} />
      {/* Scanline */}
      <div style={{ position: 'absolute', left: 0, right: 0, height: 2, background: 'linear-gradient(90deg, transparent, #00e5ff, transparent)', animation: 'scan 6s linear infinite', opacity: 0.25, pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 780 }}>
        <div style={{
          fontFamily: "'Space Mono', monospace", fontSize: '0.72rem', color: '#00e5ff',
          letterSpacing: '0.18em', textTransform: 'uppercase',
          border: '1px solid rgba(0,229,255,0.3)',
          display: 'inline-block', padding: '0.35rem 0.9rem', marginBottom: '2rem',
          animation: 'fadeUp 0.6s ease both',
        }}>
          🤖 IA & Monitoring Industriel — Stage Été 2026
        </div>

        <h1 style={{ fontSize: 'clamp(3.5rem, 8vw, 7rem)', fontWeight: 800, lineHeight: 0.95, letterSpacing: '-0.03em', marginBottom: '1.5rem', animation: 'fadeUp 0.6s 0.1s ease both' }}>
          Chaimae<br /><span style={{ color: '#00e5ff' }}>Kazoury</span>
        </h1>

        <p style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.95rem', color: '#5a8a9f', lineHeight: 1.85, maxWidth: 520, marginBottom: '2.5rem', animation: 'fadeUp 0.6s 0.2s ease both' }}>
          Étudiante en <span style={{ color: '#a8ff3e' }}>Informatique & IA</span> à ENSAM Casablanca.<br />
          Intéréssée par la <span style={{ color: '#a8ff3e' }}>détection d'anomalies</span>, monitoring<br />
          temps réel et systèmes ML sur données industrielles.
        </p>

        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', animation: 'fadeUp 0.6s 0.3s ease both' }}>
          <a href="#candidature" style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', padding: '0.9rem 2rem', background: '#00e5ff', color: '#050a0e', textDecoration: 'none', display: 'inline-block', transition: 'transform 0.2s, box-shadow 0.2s' }}
            onMouseEnter={e => { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 8px 30px rgba(0,229,255,0.35)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow=''; }}>
            Voir ma candidature
          </a>
          <a href="#projects" style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', padding: '0.9rem 2rem', background: 'transparent', color: '#e2f0f5', border: '1px solid #1a3040', textDecoration: 'none', display: 'inline-block', transition: 'border-color 0.2s, color 0.2s' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor='#00e5ff'; e.currentTarget.style.color='#00e5ff'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor='#1a3040'; e.currentTarget.style.color='#e2f0f5'; }}>
            Mes projets →
          </a>
        </div>
      </div>

      {wide && <Terminal />}
    </section>
  );
}
